module.exports = __webpack_public_path__ + "static/media/What's New is in the cards.94fdd49d.png";